import React from 'react';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  children: React.ReactNode;
  onBookNowClick: () => void;
}

const Layout: React.FC<LayoutProps> = ({ children, onBookNowClick }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header onBookNowClick={onBookNowClick} />
      <main className="flex-grow">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;